module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-8f51b3151fcd42a77dd88029d8d8ce43.jpg";